/** Runtime switches used while the old capture workflow is retired safely.
 *
 * Local development and CI default to the new slices. A preview can turn a
 * slice off explicitly with the corresponding REACT_APP flag while the
 * backend contracts remain shared and authorization-neutral.
 */
const enabled = (value: string | undefined): boolean => value !== 'false';
const explicitlyEnabled = (value: string | undefined): boolean => value === 'true';

export const features = {
  storyPreparationSave: explicitlyEnabled(process.env.REACT_APP_STORY_PREPARATION_SAVE),
  storyPreparationPreview: explicitlyEnabled(process.env.REACT_APP_STORY_PREPARATION_PREVIEW),
  stagingMode: explicitlyEnabled(process.env.REACT_APP_STAGING_MODE),
  bedtimeContextV1: enabled(process.env.REACT_APP_BEDTIME_CONTEXT_V1),
  voiceCaptureV2: enabled(process.env.REACT_APP_VOICE_CAPTURE_V2),
  accountlessDonorRoute: explicitlyEnabled(
    process.env.REACT_APP_ACCOUNTLESS_DONOR_ROUTE_ENABLED,
  ),
} as const;
